import { render, staticRenderFns } from "./MultipleAccountSelection.vue?vue&type=template&id=52a84877&scoped=true"
import script from "./MultipleAccountSelection.vue?vue&type=script&lang=ts"
export * from "./MultipleAccountSelection.vue?vue&type=script&lang=ts"
import style0 from "./MultipleAccountSelection.vue?vue&type=style&index=0&id=52a84877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a84877",
  null
  
)

export default component.exports